import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { styles } from "./styles";
import { SignatureSection } from "./SignatureSection";

export const DeclarationsComponent = ({ type, data }) => {
  return (
    <View style={[styles.section, { marginTop: 20, marginBottom: 20 }]}>
      {/* Header */}
      <Text
        style={[
          styles.text,
          {
            textAlign: "center",
            marginBottom: 5,
            marginTop: type === "PF" ? 60 : 0,
            fontSize: 13,
          },
        ]}
      >
        CONTRATO DE ARRENDAMIENTO PURO (EL “CONTRATO”) QUE CELEBRAN LAS PARTES
        AL TENOR DE LAS SIGUIENTES DECLARACIONES Y CLÁUSULAS:
      </Text>

      {/* Title */}
      <Text style={[styles.title, { fontSize: 12, marginBottom: 5 }]}>
        DECLARACIONES
      </Text>

      {/* Two Column Layout */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          fontSize: 10,
        }}
      >
        {/* Left Column: I. Arrendador (a-e) & II. Arrendatario (a-c part 1) */}
        <View style={{ width: "48%" }}>
          <Text style={[styles.text, styles.bold, { marginBottom: 5 }]}>
            I. Declara el Arrendador, a través de su representante legal:
          </Text>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              a) Que es una sociedad legalmente constituida de conformidad con
              las leyes mexicanas.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              b) Que su representante legal que en este acto comparece cuenta
              con las facultades legales suficientes para la celebración del
              presente Contrato, las cuales no le han sido revocadas, limitadas
              o modificadas de forma alguna a la fecha de la firma del presente
              Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              c) Que dentro de su objeto social se encuentra, entre otros, la
              prestación de servicios de arrendamiento de diversos tipos de
              equipos y mobiliario, entre otros bienes, así como la celebración
              de contratos o convenios de arrendamiento puro, operaciones de
              crédito y arrendamiento financiero.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              d) Que es el único y legítimo propietario del vehículo automotor
              objeto del presente Contrato o que cuenta con todas las
              autorizaciones y permisos necesarios para darlo en arrendamiento.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              e) Que en la celebración del presente Contrato no existe error,
              dolo, mala fe o cualquier otro vicio del consentimiento que
              pudiera invalidarlo o dejarlos sin efectos.
            </Text>
          </View>

          <Text
            style={[
              styles.text,
              styles.bold,
              { marginBottom: 5, marginTop: 5 },
            ]}
          >
            II. Declara el Arrendatario:
          </Text>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              a) Que es una sociedad legalmente constituida de conformidad con
              las leyes mexicanas.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              b) Que su representante legal que en este acto comparece cuenta
              con las facultades legales suficientes para la celebración del
              presente Contrato, las cuales no le han sido revocadas, limitadas
              o modificadas de forma alguna a la fecha de la firma del presente
              Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              c) Que previo a la celebración del presente Contrato, ha
              proporcionado al Arrendador toda aquella información y
              documentación que se señala en el documento que se adjunta al
              presente como Anexo 1, necesaria y suficiente para acreditar su
              personalidad, capacidad, legal existencia y facultades, así como
              solvencia económica, según corresponda, misma que, declara bajo
              protesta de decir verdad, es veraz, exacta, verdadera y cierta, y
              la cual será integrada a un expediente
            </Text>
          </View>
        </View>

        {/* Right Column: II. Arrendatario (c part 2 - i) */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              que llevará el Arrendador a efecto de identificar plenamente al
              Arrendatario.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              d) Que las declaraciones que en este acto realiza, así como
              aquella información y documentación proporcionada para la
              celebración del presente Contrato, es verídica, precisa y
              verdadera, y, por lo tanto, se hace responsable por cualquier
              daño, perjuicio o menoscabo que pueda ocasionar al Arrendador en
              caso de que dicha información o documentación no sea verídica o no
              se hayan emitido conforme a las disposiciones legales aplicables
              en la materia.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              e) Que requiere del vehículo automotor objeto del presente
              Contrato y por tanto es su voluntad celebrar el mismo bajo los
              términos y condiciones que más adelante se establecen.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              f) Que ha seleccionado el Bien Arrendado, según dicho término se
              define más adelante, objeto del presente Contrato, por su propia
              voluntad, en base a sus necesidades y preferencias, liberando al
              Arrendador de cualquier vicio del consentimiento que pudieran
              tener el Bien Arrendado.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              g) Que a la fecha de la firma del presente Contrato es solvente
              para el total y oportuno cumplimiento de sus obligaciones al
              amparo del presente Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              h) Que manifiesta bajo protesta de decir verdad que los recursos
              obtenidos para el pago de la Contraprestación y demás conceptos
              aplicables conforme al presente Contrato son y serán de
              procedencia lícita y que para todos los efectos del presente
              Contrato actúa a nombre y por cuenta propia.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              i) Que en la celebración del presente Contrato no existe error,
              dolo, mala fe o cualquier otro vicio del consentimiento que
              pudiera invalidarlo o dejarlos sin efectos.
            </Text>

            <Text style={[styles.text, styles.bold, { marginBottom: 5 }]}>
              III. Declara el Obligado Solidario, en su caso, a través de su
              representante legal / por su propio derecho:
            </Text>
            <View style={{ marginLeft: 0 }}>
              <Text style={[styles.text, { marginBottom: 5 }]}>
                a) En caso de ser persona moral: que es una sociedad legalmente
                constituida y existente conforme a las leyes mexicanas / En caso
                de ser persona física: que es una persona física de nacionalidad
                [mexicana], mayor de edad, con plena capacidad legal y jurídica
                y que no requiere de autorización alguna para la celebración del
                presente Contrato.
              </Text>
            </View>
          </View>
        </View>
      </View>

      {/* New Row for Page 2 Flow (Section III continued) */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          fontSize: 10,
        }}
      >
        {/* Left Column: III (b-h) */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              b) En caso de ser persona moral: que su representante legal que en
              este acto comparece cuenta con las facultades legales suficientes
              para la celebración del presente Contrato, las cuales no le han
              sido revocadas, limitadas o modificadas de forma alguna a la fecha
              de la firma del presente Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              c) Que previo a la celebración del presente Contrato, ha
              proporcionado al Arrendador toda aquella información y
              documentación que se señala en el documento que se adjunta al
              presente como Anexo 1, necesaria y suficiente para acreditar su
              personalidad, capacidad, legal existencia y facultades, así como
              solvencia económica, según corresponda, misma que, declara bajo
              protesta de decir verdad, es veraz, exacta, verdadera y cierta, y
              la cual será integrada a un expediente que llevará el Arrendador a
              efecto de identificar plenamente al Obligado Solidario.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              d) Que es su voluntad constituirse como obligado solidario de
              todas y cada una de las obligaciones del Arrendatario derivadas
              del presente Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              e) Que autoriza y consiente en forma expresa, que en caso de que
              el Arrendador se vea forzado a acudir ante la autoridad judicial a
              reclamar el pago y el aseguramiento de bienes, se le requiera y
              ejecute indistintamente.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              f) Que a la fecha de la firma del presente Contrato es solvente
              para el total y oportuno cumplimiento de sus obligaciones al
              amparo del presente Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              g) Que manifiesta, bajo protesta de decir verdad, que los recursos
              obtenidos para la realización de su actividad económica son y
              serán de procedencia lícita y que para todos los efectos del
              presente Contrato actúa a nombre y por cuenta propia.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              h) Que en la celebración del presente Contrato no existe error,
              dolo, mala fe o cualquier otro vicio del consentimiento que
              pudiera invalidarlo o dejarlos sin efectos.
            </Text>

            <Text
              style={[
                styles.text,
                styles.bold,
                { marginBottom: 5, marginTop: 5 },
              ]}
            >
              IV. Declaran las Partes de forma conjunta que:
            </Text>
            <View style={{ marginLeft: 0 }}>
              <Text style={[styles.text, { marginBottom: 5 }]}>
                a) Que se reconocen mutuamente la personalidad y las facultades
                con que en este acto comparecen cada una de las Partes.
              </Text>
              <Text style={[styles.text, { marginBottom: 5 }]}>
                b) Que es su deseo celebrar el presente Contrato por lo que
                manifiestan expresamente su voluntad sujetándose a las
                siguientes:
              </Text>
              <Text style={[styles.text, { marginBottom: 5 }]}>
                c) En virtud de las declaraciones anteriores las Partes
                convienen en otorgar las siguientes:
              </Text>
            </View>
          </View>
        </View>

        {/* Right Column: Clauses */}
        <View style={{ width: "48%" }}>
          <Text
            style={[
              styles.title,
              {
                fontSize: 12,
                marginBottom: 5,
                textAlign: "center",
                marginTop: 15,
              },
            ]}
          >
            CLÁUSULAS
          </Text>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              <Text style={styles.bold}>PRIMERA. </Text>
              Por virtud del presente Contrato el Arrendador da en arrendamiento
              al Arrendatario y éste toma en arrendamiento el automóvil cuyas
              características, número de serie, refacciones, accesorios y demás
              partes, así como sus calidades y cualidades se describen
              detalladamente en la Carátula del presente Contrato y que forma
              parte integral del mismo (en adelante al vehículo, el "Bien
              Arrendado").
            </Text>

            <Text style={[styles.text, { marginBottom: 5 }]}>
              <Text style={styles.bold}>SEGUNDA. </Text>
              El Arrendatario se obliga a pagar al Arrendador, la renta mensual
              que se establece en la Carátula del presente Contrato, en el
              entendido que, a dicha cantidad deberá sumársele el Impuesto al
              Valor Agregado ("IVA") correspondiente (en adelante la
              "Contraprestación"). En el supuesto que el Arrendatario continúe
              en posesión del Bien Arrendado una vez terminado el plazo de
              vigencia del presente Contrato y el mismo no hubiera sido
              prorrogado previo acuerdo por escrito entre las Partes, la
              Contraprestación se incrementará automáticamente en un 100% (cien
              por ciento).
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              De igual modo, el Arrendatario se obliga a pagar al Arrendador una
              cuota mensual de administración por la cantidad, más IVA, que se
              señala en la Carátula (la "Cuota de Administración").
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Las Partes convienen que la Contraprestación y la Cuota de
              Administración se pagarán de forma mensual por adelantado en la
              fecha de corte estipulada en la tabla de pagos del Arrendatario, a
              la cuenta que se señala en la Carátula, mismas que serán cubiertas
              mediante la domiciliación del pago a la cuenta bancaria o de
              cheques del Arrendatario, a satisfacción del Arrendador, en moneda
              de curso legal y en fondos inmediatamente transferibles y
              disponibles o en su defecto, mediante transferencia electrónica,
              depósito bancario o aquellos otros medios que oportunamente
              acuerden las Partes según conste en un documento por separado.
              Ante imposibilidad de realizar el pago en términos de lo anterior,
              el Arrendatario se obliga llevar a cabo el pago en el domicilio
              del Arrendador con cheque de caja o cheque certificado dentro del
              mismo plazo.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Las Partes convienen que contra el pago de la Contraprestación y
              de la Cuota de Administración, el Arrendador entregará al
              Arrendatario una factura por cada concepto y por la cantidad
              correspondiente a cada uno, las cuales deberán de cumplir con
              todos los requisitos legales y fiscales aplicables al momento de
              su emisión.
            </Text>
          </View>
        </View>
      </View>

      {/* New Row for Page 3 Flow (Clauses continued) */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          fontSize: 10,
        }}
      >
        {/* Left Column: Empty */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              El pago de la Contraprestación se acreditará de acuerdo con el
              medio de pago que utilice el Arrendatario y sea aprobado por el
              Arrendador:
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              <Text style={styles.bold}>Domiciliación:</Text> se acreditará a
              más tardar en la fecha límite de pago del presente contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              <Text style={styles.bold}>
                Transferencias electrónicas de fondos:
              </Text>
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 20 }]}>
              (i) a través del Sistema de Pagos Electrónicos Interbancarios
              (SPEI), o mediante cargos y abonos a cuentas en el mismo banco que
              la cuenta receptora del Arrendador, se acreditará en el mismo día
              hábil en que se ordene la transferencia con la cuenta referenciada
              proporcionada por el Arrendador o
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 20 }]}>
              (ii) a través del Sistema de Pagos Electrónicos, se acreditará a
              más tardar el día hábil siguiente al que se ordene la
              transferencia.
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              <Text style={styles.bold}>Terminal punto de venta:</Text> se
              acreditará el día hábil que establezca la institución bancaria que
              corresponda.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Lo anterior en el entendido que ciertas operaciones realizadas a
              través de instituciones bancarias podrán generar una comisión a
              cargo del Arrendatario, por lo que este se compromete a cubrirlas
              según la forma de pago que elija para el cumplimiento de sus
              obligaciones al amparo del presente Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              La Contraprestación, así como la Cuota de Administración
              estipuladas en la presente Cláusula serán pagaderas y se
              computarán por períodos mensuales independientemente de que en
              algún caso el Bien Arrendado esté en posesión del Arrendatario,
              por un período inferior a un mes.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Asimismo y adicional a la Contraprestación mensual y a la Cuota de
              Administración, el Arrendatario pagará al Arrendador, por única
              ocasión a más tardar la fecha de firma del presente Contrato, el
              gasto inicial de arrendamiento, una comisión por apertura, el
              depósito de garantía y el primer pago mensual (conjuntamente, el
              "Desembolso Inicial"), mismos que se establecen en la Carátula del
              presente Contrato, más el Impuesto al Valor Agregado ("IVA")
              correspondiente y serán pagaderos en términos de lo dispuesto en
              la presente Cláusula.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Las Partes convienen que los gastos que se generen por la
              realización de las gestiones necesarias
            </Text>
          </View>
        </View>

        {/* Right Column: Clauses continued */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              para la obtención de toda la documentación relacionada con el Bien
              Arrendado objeto del presente Contrato incluidas las gestiones
              para el pago de las placas del vehículo, según resulte aplicable,
              serán por cuenta del Arrendatario en los términos de lo
              establecido en la Carátula del presente Contrato.
            </Text>

            <Text style={[styles.text, { marginBottom: 5 }]}>
              <Text style={styles.bold}>TERCERA. </Text>
              <Text>
                {" "}
                Vigencia, Forma de Pago y Fechas de Aplicación del pago
              </Text>
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Las Partes convienen que el plazo de vigencia del presente
              Contrato será el que se establezca en la Carátula, por lo que este
              Contrato concluirá su vigencia una vez que hubiera transcurrido el
              mismo, en el entendido de que el Arrendatario deberá de haber
              cubierto todas y cada una de las Contraprestaciones y Pagos de
              Administración y demás costos y gastos aplicables, así como
              cumplido con la totalidad de sus obligaciones al amparo del
              presente Contrato y sus Anexos.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Previo a la terminación de la vigencia del presente Contrato en
              términos de la Carátula, las Partes podrán optar entre la compra
              del bien Arrendado, la devolución del Bien Arrendado o la prórroga
              del presente Contrato, según conste en acuerdo previo por escrito
              entre las Partes en el entendido que (i) si las partes no logran
              un acuerdo respecto del Bien Arrendado en términos del presente
              Contrato, y (ii) el Arrendatario no devolviere en la fecha de
              terminación el Bien Arrendado, este Contrato se considerará
              prorrogado y la Contraprestación y la Cuota de Administración se
              incrementarán automáticamente en un 100% (cien por ciento), por lo
              que el Arrendatario deberá pagar las mismas en dichos términos
              durante los meses de uso del Bien Arrendado, sin necesidad de
              declaración judicial.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Todas las cantidades que el Arrendatario deba pagar al Arrendador,
              las cubrirá por domiciliación a más tardar en las fechas
              convenidas, sin necesidad de requerimiento previo judicial o
              extrajudicial, a satisfacción del Arrendador en moneda de curso
              legal y en fondos transferibles y disponibles el mismo día o
              anticipadamente, debiendo efectuarse dichos pagos a más tardar en
              un "día hábil" que no sea posterior a su fecha de pago a través de
              la domiciliación de cobro por parte del Arrendador, trasferencia
              bancaria o a través de instituciones bancarias o por cualquier
              otro medio, incluyendo los electrónicos que al efecto el
              Arrendador notifique al Arrendatario.
            </Text>
          </View>
        </View>
      </View>

      {/* New Row for Page 4 Flow */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          fontSize: 10,
        }}
      >
        {/* Left Column */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5, marginTop: 30 }]}>
              <Text>CUARTA. </Text>Formas para entregar el bien. Las Partes
              convienen que el Arrendador entregará al Arrendatario el Bien
              Arrendado y 1 (un) juego de llaves del mismo: (i) en el momento de
              la entrega del vehículo, en el domicilio del Arrendador, si la
              entrega la realiza directamente el Arrendador, o (ii) dentro de
              los 30 (treinta) días naturales posteriores a la firma del
              presente Contrato, si la entrega se realiza por conducto del
              vendedor, proveedor o distribuidor del Bien Arrendado, salvo que
              exista caso fortuito o fuerza mayor que se lo impida, o bien,
              exista cualquier otro motivo que no sea imputable al Arrendador,
              incluyendo sin limitar que no haya disponibilidad o existencia del
              Bien Arrendado, o por la demora por parte del vendedor, proveedor
              o distribuidor del Bien Arrendado o bien, cualquier otro motivo
              que no sea responsabilidad del Arrendador, por lo cual desde este
              momento el Arrendatario libera de cualquier responsabilidad al
              Arrendador respecto de lo anterior.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Para la entrega del bien se levantará un acta de entrega en
              términos del documento que se adjunta al presente como Anexo 2, la
              cual, deberá ser firmada en todo caso por el representante legal
              del Arrendatario o persona autorizada por este, y una vez firmado
              formará parte integrante del presente Contrato, con plena validez
              jurídica.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              En caso de que se requieran condiciones de entrega que impliquen
              el manejo o realización de maniobras especiales, el Arrendador
              entregará al Arrendatario una cotización respecto del costo
              adicional de dichos servicios de entrega.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Asimismo, las Partes convienen que, en caso de que el Arrendatario
              se niegue a recibir el Bien Arrendado, se estará al pago de la
              pena convencional establecida en la Cláusula Décimo Octava del
              presente Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              El Arrendatario reconoce y acepta que ha seleccionado directa y
              libremente el Bien Arrendado (incluyendo, sin limitación, la
              marca, capacidad, tipo, modelo, calidad, comerciabilidad y demás
              especificaciones), por lo que en este acto reconoce y conviene que
              el Arrendador no será responsable de ningún error u omisión en la
              descripción del Bien Arrendado (o cualquier parte del mismo) y el
              Arrendatario está conforme y de acuerdo con todos y cada uno de
              los términos, condiciones, descripciones y especificaciones
              actuales del Bien Arrendado y lo acepta y recibe a su entera
              satisfacción.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              En virtud de lo dispuesto en la presente Cláusula, el Arrendatario
              en este acto
            </Text>
          </View>
        </View>

        {/* Right Column: CUARTA Clause */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              libera de manera expresa e irrevocable al Arrendador de cualquier
              responsabilidad, presente o futura, derivada de o relacionada con
              el Bien Arrendado o cualquier parte del mismo, incluyendo, sin
              limitación alguna, de cualesquier responsabilidad derivada de o
              relacionada con cualquier pérdida, daño, defecto de fabricación o
              vicio (oculto o manifiesto), error u omisión en dicho Bien
              Arrendado (o cualquier parte del mismo), en su descripción o
              diferencias en las especificaciones del Bien Arrendado, o
              cualquier otro incumplimiento en la entrega, manufactura o
              ensamble del Bien Arrendado o cualquier parte del mismo, en el
              entendido que los defectos de fabricación, para efectos del
              presente Contrato se entenderán como aquellos desperfectos que se
              encuentren cubiertos por la garantía del fabricante en las pólizas
              correspondientes durante el término establecido en las mismas y
              que no sean producto del desgaste natural de los componentes del
              Bien Arrendado.
            </Text>

            <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
              <Text style={styles.bold}>QUINTA. </Text>
              Intereses Moratorios y Comisión por Gastos de Cobranza
              <Text style={[styles.text, { marginBottom: 5 }]}>
                La falta de pago oportuno por parte del Arrendatario de la
                Contraprestación y Cuota de Administración generará a cargo del
                Arrendatario intereses moratorios que serán computados de manera
                diaria a una tasa de 0.5% (cero punto cinco por ciento) diario
                sobre todas y cada una de las cantidades adeudadas, hasta la
                total liquidación del adeudo, más el IVA aplicable que se
                origine por concepto de dichos intereses.
              </Text>
            </Text>

            <Text style={[styles.text, { marginBottom: 5 }]}>
              Asimismo, la falta de pago oportuno por parte del Arrendatario de
              la Contraprestación y Cuota de Administración en términos de la
              Cláusula Segunda del presente Contrato, originará una comisión por
              acciones de cobranza, por cada evento y por la cantidad que se
              establece en la Carátula del presente Contrato (los "Gastos de
              Cobranza"), las cuales comprenden todos aquellos procesos que
              queden registrados en el Sistema Electrónico de Gestión utilizado
              por el Arrendador, así como todas las acciones de búsqueda de
              información adicional, las acciones realizadas por terceros
              contratados por el Arrendador y las acciones por las que se haga
              llegar al Arrendatario una gestión de cobro.
            </Text>

            <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
              <Text style={styles.bold}>SEXTA. </Text>
              Depósito en Garantía. El Arrendatario se obliga a constituir, en
              favor del Arrendador, un depósito en garantía cuyo monto se
              establece en la Carátula, a efecto de garantizar, en forma
              general, el puntual y oportuno cumplimiento de las obligaciones a
              su cargo en el presente Contrato y sus Anexos; y en forma
              particular, la devolución oportuna del Bien Arrendado.
            </Text>
          </View>
        </View>
      </View>

      {/* New Row for Page 5 Flow (SEXTA Clause continued) */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          fontSize: 10,
        }}
      >
        {/* Left Column: SEXTA continued */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Al término del presente Contrato, si el Arrendatario se encuentra
              al corriente en el cumplimiento de sus obligaciones, opta por
              devolver el Bien Arrendado y lo devuelve en los términos
              convenidos en el presente Contrato, el Arrendador se obliga a
              devolver el depósito dentro de los 120 (ciento veinte) días
              naturales siguientes a la terminación del presente Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Si al término del presente Contrato, el Arrendatario se encuentra
              al corriente en el cumplimiento de sus obligaciones y opta por
              comprar el Bien Arrendado, el depósito en garantía se tomará a
              cuenta del pago del valor residual del Bien Arrendado.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              No obstante lo anterior, en el supuesto de que, al término del
              Contrato, el Bien Arrendado no hubiere sido devuelto o existieren
              obligaciones de pago insolutas a cargo del Arrendatario, el
              Arrendador podrá descontar las cantidades que resultaren
              aplicables del mencionado depósito, en cuyo caso la devolución de
              este se hará sobre el remanente una vez devuelto el Bien Arrendado
              y cumplidas las obligaciones de pago, siempre y cuando las mismas
              hubieren sido cubiertas con anterioridad al descuento.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Las Partes convienen que el mencionado depósito en garantía, en
              ningún supuesto será tomado a cuenta del pago de Contraprestación
              alguna durante la vigencia del presente Contrato y sus Anexos. No
              obstante lo anterior, el Arrendador podrá optar por tomar dicho
              depósito cuando el Arrendatario incurra en un atraso de 30
              (treinta) días naturales o más en el pago de cualquiera de sus
              obligaciones, incluyendo sin limitar la Contraprestación, Cuota de
              Administración, Gastos de Cobranza y Gastos de Recuperación, con
              el fin de descontar y cobrar las cantidades adeudadas, y
              únicamente en caso de que existiera un remanente, este podrá
              devolverse al Arrendatario.
            </Text>

            <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
              <Text style={styles.bold}>SÉPTIMA. </Text>
              Consecuencias por daño, deterioro, destrucción o pérdida del Bien
              Arrendado
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              El Arrendatario en este acto se obliga a asumir el riesgo total de
              cualquier pérdida, robo, daño o destrucción del Bien Arrendado por
              cualquier causa incluyendo el caso fortuito o fuerza mayor, a
              partir del momento de la entrega de este al Arrendatario,
              obligándose a pagar en términos de lo aquí establecido la
              Contraprestación y Cuota de Administración durante la vigencia del
              presente Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              El Arrendatario conviene expresamente en que todos y cada uno de
              los riesgos derivados de, o relacionados con los puntos
            </Text>
          </View>
        </View>

        {/* Right Column: SÉPTIMA continued */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              que se mencionan a continuación (cada uno para efectos del
              presente Contrato un "Evento de Pérdida"), serán a cargo, y por
              cuenta exclusiva del Arrendatario, debiendo notificar
              inmediatamente por escrito al Arrendador y a la aseguradora con
              quien se contrate el seguro del Bien Arrendado a los números
              telefónicos y correos electrónicos que se indiquen en la póliza
              respectiva, de la existencia de cualquier Evento de Pérdida a más
              tardar el día hábil siguiente a la fecha en que dicho Evento de
              Pérdida ocurra:
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              (i) La aparición de vicios o defectos, ya sean ocultos o
              manifiestos que vuelvan inutilizable el Bien Arrendado o cualquier
              parte de este;
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              (ii) La pérdida total del Bien Arrendado (o cualquier parte de
              este), aún en el supuesto de caso fortuito o fuerza mayor;
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              (iii) Los daños totales, robo o destrucción del Bien Arrendado (o
              cualquier parte de este), aún en el supuesto de caso fortuito o
              fuerza mayor, o si el Bien Arrendado se vuelve inutilizable de
              forma permanente, o en caso de cualquier expropiación o
              confiscación de la propiedad o el uso del Bien Arrendado por parte
              de cualquier autoridad gubernamental; o
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              (iv) Si por alguna razón el Bien Arrendado, o su motor o
              cualquiera de sus partes, se desgastara, perdiera, extraviara,
              fuera robada, detenida, confiscada, incautada, expropiada,
              requisada, secuestrada, destruida, dañada irreparablemente,
              inaccesible (geográficamente o de otra manera) o inutilizable.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Posteriormente a que el Arrendatario notifique al Arrendador y a
              la aseguradora de la existencia de un Evento de Pérdida, y una vez
              que la aseguradora determine y acredite que efectivamente ocurrió
              dicho Evento de Pérdida mediante la entrega de la carta de pérdida
              total (la "Carta de Pérdida") al beneficiario del seguro del Bien
              Arrendado, el Arrendador podrá dar por terminado el Contrato, en
              cuyo caso el Arrendatario deberá pagar al Arrendador, dentro de
              los 3 (tres) días hábiles siguientes a la fecha de expedición de
              la Carta de Pérdida (i) todos los pagos de la Contraprestación y
              Cuota de Administración vencidos y no pagados que se hubieren
              generado previo a la expedición de la Carta de Pérdida y (ii)
              cualquier otra cantidad adeudada al Arrendador, incluyendo, en su
              caso, los daños causados a terceros. El incumplimiento del
              Arrendatario de pagar las cantidades referidas anteriormente en la
              Fecha de Pago por Evento de Pérdida generará intereses moratorios
              a la tasa establecida en la Cláusula Quinta anterior.
            </Text>
          </View>
        </View>
      </View>

      {/* New Row for Page 7 Flow (SÉPTIMA Clause continued) */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          fontSize: 10,
        }}
      >
        {/* Left Column: SÉPTIMA continued - theft reporting obligations */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              No obstante lo anterior, en caso de un Evento de Pérdida por robo
              total del vehículo al Arrendatario, está obligado a denunciar el
              robo ante las autoridades correspondientes en la localidad donde
              hubiere ocurrido y deberá de recabar copia certificada de la
              denuncia inicial donde se especifiquen los detalles del robo,
              incluyendo sin limitar cómo, cuándo y dónde ocurrió el mismo. Es
              obligación del Arrendatario, solicitar al Ministerio Público con
              el que se realizó la denuncia, el acta para acreditar la propiedad
              del Bien Arrendado en donde quede asentado de forma correcta los
              datos de la carta factura del Bien Arrendado, incluyendo la razón
              social del Arrendador, fecha de expedición, numero de factura, así
              como los datos generales del Bien Arrendado: marca, tipo de
              vehículo, modelo, número de serie, número de motor, y demás que
              resulten necesarios. Una vez recabada la copia certificada de
              dicha denuncia, el Arrendatario deberá de entregar la copia
              certificada de la denuncia a la aseguradora a más tardar el día
              hábil siguiente a aquel en que la misma haya sido expedida.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Si el Arrendatario por cualquier circunstancia no realizare la
              denuncia del robo ante las autoridades correspondientes o no
              recabare la copia certificada de la denuncia, el Arrendatario
              continuará obligado al pago de la Contraprestación y Cuota de
              Administración, junto con cualesquier intereses, comisiones y
              demás accesorios previstos en este Contrato en términos de este.
              Dichas obligaciones de pago subsistirán en tanto el Arrendatario
              no realice la denuncia y entregue la copia certificada de la misma
              a la aseguradora, y notifique de dicha circunstancia al
              Arrendador. Por lo anterior, el Arrendatario libera al Arrendador
              de cualquier tipo de responsabilidad relacionada con lo anterior.
              En dicho supuesto, el Arrendador quedará facultado para llevar a
              cabo la denuncia y el Arrendatario continuará obligado al pago de
              todas y cada una de las obligaciones de pago enunciadas en esta
              Cláusula y en el presente Contrato e inclusive el Arrendador podrá
              tomar el depósito en garantía del Arrendatario para cubrir el pago
              sobre el monto del deducible a la aseguradora para cubrir el pago
              del mismo, en el supuesto de que este monto de pago sea menor al
              deducible y se tenga saldo pendiente, el Arrendatario tendrá la
              obligación de cubrir el remanente, para que este el pago del
              deducible a la aseguradora en tiempo y forma, en caso contrario
              donde el depósito en garantía cubra el monto del deducible y
              exista un saldo a favor, una vez realizado todos los pagos de las
              obligaciones que llegare a tener pendiente el Arrendatario, se
              podrá devolver el remanente al cierre del contrato.
            </Text>
          </View>
        </View>

        {/* Right Column: OCTAVA clause */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              <Text style={styles.bold}>OCTAVA. </Text>
              Dispositivo de Geolocalización El Arrendatario acepta y reconoce
              que el Arrendador utilizará un Dispositivo de Geolocalización para
              seguir o localizar el Bien Arrendado en caso de robo, o cuando
              exista sospecha de que ha sido robado o conforme lo requiera
              cualquier autoridad competente para ello, o para identificar
              cuando el Bien Arrendado sufra daños o requiera asistencia, así
              como para atender cualquier evento de emergencia que pudiera poner
              en riesgo la seguridad del Arrendatario o de cualquier otra
              persona, o cuando sea necesario para defender, proteger o hacer
              valer todos y cada uno de los derechos del Arrendador conforme al
              presente Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Por lo anterior, en este acto el Arrendatario acepta y reconoce
              que el Bien Arrendado podrá contar con un equipo que recopilará,
              almacenará y transferirá información sobre éste incluyendo, entre
              otras, su ubicación, traslados y geolocalización, así como
              información de seguridad, información general relacionada con el
              uso y operación del Bien Arrendado, diagnósticos varios y códigos
              de error (en adelante el "Dispositivo de Geolocalización"). El
              Arrendatario autoriza expresamente en este acto al Arrendador para
              que instale y ponga en operación en el Bien Arrendado el
              Dispositivo de Geolocalización que en adición a las funciones
              descritas anteriormente podrá inhibir el sistema eléctrico y
              motriz del Bien Arrendado.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              En caso de incumplimiento por parte del Arrendatario a cualquiera
              de sus obligaciones contenidas en este Contrato, el Arrendatario
              autoriza expresamente al Arrendador para que active el Dispositivo
              de Geolocalización, y consiente y acepta en este acto que el
              Arrendador, por este motivo, no incurrirá en responsabilidad
              alguna de ningún tipo y naturaleza.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              En caso de que las funciones de inhibición del sistema eléctrico y
              motriz del Dispositivo de Geolocalización se activen por error del
              sistema del Dispositivo de Geolocalización y el Bien Arrendado
              quede inmovilizado, el Arrendatario deberá dar aviso al Arrendador
              de inmediato para que en un plazo razonable se verifiquen las
              condiciones del Dispositivo de Geolocalización y la falla se
              corrija, sin que incurran en responsabilidad alguna ninguna de las
              Partes de este Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Las Partes convienen, además, que el Dispositivo de
              Geolocalización no deberá ser removido del Bien Arrendado sin
              notificación previa y por escrito al Arrendador. Cualquier intento
              o acción tendiente para inutilizar, modificar, retirar o de
              cualquier manera alterar el Dispositivo de Geolocalización
            </Text>
          </View>
        </View>
      </View>

      {/* New Row for Page 8 Flow (OCTAVA Clause continued) */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          fontSize: 10,
        }}
      >
        {/* Left Column: NOVENA clause */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              constituirá un apoderamiento con ánimo de dominio sin
              consentimiento del Arrendador.
            </Text>

            <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
              <Text style={[styles.text, { marginBottom: 5 }]}>
                <Text style={styles.bold}>NOVENA. </Text>
                Mantenimiento, Accidentes y Uso del Bien Arrendado
              </Text>
              (1) El Arrendatario se obliga a proporcionar al Bien Arrendado, a
              su entera costa y responsabilidad, directamente con el fabricante
              o con el proveedor autorizado por éste, (i) el mantenimiento
              preventivo y/o correctivo que este requiera y sea necesario para
              su óptimo funcionamiento en los términos descritos por el
              fabricante del Bien Arrendado en el manual del usuario de éste o
              su equivalente, y (ii) cualquier mantenimiento o reparación en
              caso de descompostura, falla o cualquier caso similar por causas
              imputables al Arrendatario, por lo que, para tales efectos, estará
              obligado a llevar el Bien Arrendado al domicilio que corresponda
              al fabricante o al proveedor autorizado.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Para efectos de lo anterior, las Partes convienen que en cualquier
              caso se utilizarán servicios de mantenimiento y compostura, así
              como refacciones originales de la o las marcas autorizadas por el
              fabricante del Bien Arrendado, que permitan la conservación de las
              garantías del fabricante y conserven el valor del Bien Arrendado.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              (2) En caso de que, por descompostura, accidente o cualquier otra
              causa similar, el Arrendatario se viera impedido de utilizar el
              Bien Arrendado por cualesquiera periodos de tiempo, tal situación
              no lo eximirá del cumplimiento de sus obligaciones al amparo del
              presente Contrato, siempre y cuando no sea por causas imputables
              al Arrendador, ni tendrá derecho a que se le proporcione otro
              vehículo automotor.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              (3) Las Partes convienen que el Bien Arrendado podrá ser destinado
              para transportar personas o cosas que legalmente puedan
              transportarse, lo anterior acorde a la naturaleza del Bien
              Arrendado y siempre y cuando éste tenga y cuente con las
              características necesarias y suficientes para dicho uso; debiendo
              en todo caso el Arrendatario obtener y mantener los permisos y
              licencias necesarias y aplicables para la legal circulación del
              Bien Arrendado.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              En caso de infracción respecto de lo anterior, el Arrendatario
              libera de toda responsabilidad ya sea civil, mercantil, fiscal,
              administrativa y en su caso penal al Arrendador frente a cualquier
              autoridad y/o tercero. Si con motivo de infracción a lo aquí
              establecido el Bien Arrendado fuere retenido ya sea temporal o
              definitivamente por cualquier autoridad o tercero, el Arrendatario
              estará obligada a cubrir a favor del Arrendador
            </Text>
          </View>
        </View>

        {/* Right Column: Empty for now */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              el precio del Bien Arrendado, a valor de reposición de un
              automóvil nuevo de idénticas o similares condiciones y una vez que
              tal valor haya sido cubierto al Arrendador, el Arrendatario se
              subrogará en los derechos de éste para continuar los trámites
              tendientes a recuperar el Bien Arrendado.
            </Text>

            <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
              <Text style={[styles.text, { marginBottom: 5 }]}>
                <Text style={styles.bold}>DÉCIMA. </Text>
                Revisiones
              </Text>
              El Arrendador se reserva el derecho en todo momento, previa
              notificación por escrito al Arrendatario con por lo menos 48
              (cuarenta y ocho) horas de anticipación, para que por sí mismo o
              por conducto de persona autorizada por él, en cualquier lugar o
              ubicación del Bien Arrendado, lleve a cabo la inspección de éste,
              debiendo en todo caso el Arrendatario entregar los registros de
              mantenimiento, así como cualquier otra información o documentación
              derivada de, o relacionada con, el Bien Arrendado, a efecto de
              verificar la adecuada operación, identificación y mantenimiento
              del Bien Arrendado, así como el cumplimiento y satisfacción de
              todas y cada una de las obligaciones del Arrendatario derivadas
              de, o relacionadas con, el presente Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Asimismo, el Arrendador tendrá en todo momento derecho de
              inspeccionar el odómetro del Bien Arrendado para asegurarse que no
              se ha roto ningún sello adherido al mismo y que el odómetro no ha
              sido alterado.
            </Text>

            <Text style={[styles.text, { marginBottom: 5 }]}>
              <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
                <Text style={styles.bold}>DÉCIMO PRIMERA. </Text>
                Responsabilidad del Arrendatario
              </Text>
              (1) El Arrendatario utilizará el Bien Arrendado con la precaución
              requerida y de conformidad con los requisitos de garantía
              aplicables y las instrucciones de operación del fabricante,
              incluido el manual de usuario, así como con los reglamentos de
              tránsito aplicables. En ningún caso, se utilizará el Bien
              Arrendado para transportar sustancias peligrosas, en competencias
              y/o carreras deportivas o cualesquiera otros fines distintos a los
              señalados en el inciso (3) de la Cláusula Novena anterior.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Asimismo, las Partes convienen que el uso del Bien Arrendado en
              los Estados Unidos de América y Canadá, en su caso, estará sujeto
              a la autorización previa y por escrito del Arrendador y no
              excederá de 30 (treinta) días naturales consecutivos a partir de
              su fecha de salida. Salvo por lo establecido anteriormente, el
              Bien Arrendado no podrá utilizarse fuera de los Estados Unidos
              Mexicanos.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Adicionalmente a cualquier obligación a cargo del Arrendatario en
              los términos del presente Contrato o sus Anexos, el Arrendatario
              se obliga a, y será el único responsable de:
            </Text>
          </View>
        </View>
      </View>

      {/* New Row for Page 9 Flow (DÉCIMO PRIMERA continued) */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          fontSize: 10,
        }}
      >
        {/* Left Column: DÉCIMO PRIMERA continued */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              a) Recibir el Bien Arrendado directamente del Arrendador o de la
              persona que éste designe en las condiciones que fueron
              establecidas y pactadas en la Carátula.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              b) Al término del presente Contrato entregar al Arrendador, en su
              caso, todos los documentos relativos al mismo, tales como
              facturas, boletas de pago de impuestos (incluyendo sin limitación
              impuesto a la tenencia vehicular), certificados, registros,
              licencias, verificaciones ambientales, permisos, pedimentos de
              importación y demás documentos aplicables.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              c) Cumplir con todas las leyes, reglamentos, ordenamientos,
              circulares o decretos de cualquier autoridad gubernamental,
              relacionadas con el uso, posesión u operación del Bien Arrendado,
              así como tramitar, obtener y mantener vigente todas aquellas
              licencias y permisos para conducir expedidas por la autoridad
              competente que corresponda, incluidas las verificaciones
              vehiculares (en cuyo caso el Arrendador entregará una carta poder
              en términos sustancialmente similares al formato del Anexo 5 con
              el fin de que el Arrendatario pueda acudir a realizar las mismas),
              al igual que a contar con la tarjeta de circulación y póliza de
              seguro en términos de la Cláusula Décimo Sexta siguiente.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              d) Mantener el Bien Arrendado al corriente y libre de adeudos
              vehiculares y/o infracciones, facultando expresamente al
              Arrendador a realizar los pagos correspondientes incluyendo los
              recargos que apliquen en su caso, por cuenta y orden del
              Arrendatario, debiendo reembolsar el Arrendatario todos y cada uno
              de los gastos erogados por el Arrendador respecto de los conceptos
              antes mencionados dentro de los 3 (tres) días hábiles siguientes
              al requerimiento por parte del Arrendador al Arrendatario.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              e) No constituir, imponer, asumir o permitir la constitución,
              existencia o imposición de cualquier clase de gravamen, carga o
              limitación alguna, sobre el Bien Arrendado.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              f) Adquirir, por su cuenta y costo, y utilizar exclusivamente
              refacciones, herramientas y partes nuevas y originales del
              fabricante para reparaciones derivadas del uso ordinario del Bien
              Arrendado.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              g) Defender el Bien Arrendado, así como la propiedad, titularidad
              y derechos del Arrendador sobre el mismo, contra las reclamaciones
              y demandas de cualquier tercero y llevar a cabo todas las acciones
              que resulten necesarias en relación con lo anterior, así como para
              recuperar o defender el uso y goce del Bien Arrendado. El
              Arrendatario deberá, tan pronto
            </Text>
          </View>
        </View>

        {/* Right Column: DÉCIMO PRIMERA continued - points h to p and sections 2 and 3 */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              como sea posible, pero a más tardar al tercer día hábil siguiente
              a la fecha en que cualquiera de dichas circunstancias o eventos
              ocurran, notificar por escrito al Arrendador de dicha
              circunstancia o evento. Las Partes convienen en que (i) el
              Arrendatario será responsable de los daños y perjuicios causados
              al Arrendador por el retraso o falta de entrega de dicha
              notificación; y (ii) el Arrendador, en la medida en que resulte
              necesario, legitimará al Arrendatario para que ejercite, en su
              representación, cualesquiera de dichas acciones o defensas, sin
              perjuicio del derecho del Arrendador de ejercitarlas directamente
              o en adición a las ejercitadas por el Arrendatario, lo anterior a
              costo del Arrendatario.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              h) A notificar al Arrendador respecto de cualquier emplazamiento o
              notificación de cualquier acción, demanda o procedimiento en la
              que el Arrendatario sea parte, debiendo describir la naturaleza de
              dicha acción, demanda o procedimiento y las acciones o medidas
              tomadas o que se propone tomar al respecto el Arrendatario, lo
              anterior dentro de los 3 (tres) días hábiles siguientes a la fecha
              en que el Arrendatario tenga conocimiento de cualquier acción,
              demanda o procedimiento.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              i) Reembolsar al Arrendador, tan pronto como éste se lo solicite,
              cualquier cantidad que el Arrendador hubiere pagado por cuenta del
              Arrendatario, por obligaciones de pago a cargo del Arrendatario
              derivadas de o relacionadas con el presente Contrato o sus Anexos
              o cualquier otro documento derivado o relacionado con los mismos,
              tales como multas, sanciones y cualesquiera otros gastos, según
              sea aplicable.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              j) Informar por escrito al Arrendador, a más tardar dentro de los
              3 (tres) días naturales siguientes, si el Bien Arrendado se pierde
              o se daña o si el Bien Arrendado se ve involucrado en un accidente
              causando daño a personas o a propiedad de terceros.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              k) No realizar ninguna modificación o alteración al Bien
              Arrendado, ya sea en su totalidad o en parte.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              l) A mantener, inspeccionar, dar servicio, pagar, reparar, dar
              mantenimiento al Bien Arrendado de conformidad con los manuales de
              mantenimiento del fabricante para mantener el Bien Arrendado en
              condiciones óptimas de operación en términos de lo dispuesto en la
              Cláusula Novena.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              m) Cubrir las cuotas del seguro en los términos previstos en la
              Cláusula Décimo Sexta.
            </Text>
          </View>
        </View>
      </View>

      {/* New Row for Page 10 Flow (DÉCIMO PRIMERA continued - n to p and sections 2-3) */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          fontSize: 10,
        }}
      >
        {/* Left Column: DÉCIMO PRIMERA continued - points n, o, p and sections 2, 3 */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              n) El Arrendatario conviene expresamente en este acto en que le
              está estrictamente prohibido y no podrá incorporar, dar de alta,
              usar o incluir el Bien Arrendado en ninguna plataforma o
              aplicación tecnológica que brinde, apoyo o dé soporte a ninguna
              red de taxis o servicio de intermediación de traslado o de
              transporte privado o público.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              o) Asumir todos los riesgos derivados de la pérdida, robo o daños
              que sufra el Bien Arrendado en términos de lo dispuesto en la
              Cláusula Séptima.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              p) A utilizar el Bien Arrendado por un kilometraje que no rebase
              los 20,000 km (veinte mil kilómetros) por año; en caso de exceder
              dicha distancia anualmente, el Arrendatario se obliga a pagar
              $1.50 (un peso 50/00, moneda nacional) más IVA por cada kilómetro
              adicional.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              (2) El incumplimiento a lo pactado en la presente Cláusula será
              causa de rescisión en términos de la Cláusula Décimo Octava del
              presente Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              (3) El Arrendatario conservará en todo tiempo y lugar la posesión
              del Bien Arrendado, por lo que si éste fuese embargado o en
              cualquier otra forma gravado por cualquier acreedor del
              Arrendatario, éste se compromete a sacar en paz y a salvo al
              Arrendador e indemnizarlo por los daños y perjuicios que se
              causen, asimismo, deberá coadyuvar con el Arrendador en las
              gestiones judiciales o extrajudiciales que sean necesarias para
              obtener el levantamiento del embargo o la reivindicación del Bien
              Arrendado.
            </Text>

            <Text style={[styles.text, { marginBottom: 5 }]}>
              <Text style={styles.bold}>DÉCIMO SEGUNDA. </Text>Obligación
              Solidaria. El Obligado Solidario, expresamente y en términos de lo
              dispuesto por los artículos 1987, 1988 y demás relativos del
              Código Civil Federal, asume solidariamente con el Arrendatario,
              todas y cada una de las obligaciones que a su cargo se derivan,
              incluyendo cualquier beneficio de orden, excusión, preferencia,
              disminución o cualquier otro análogo, constituyéndose en
              consecuencia, en obligado solidario del Arrendatario y respecto
              del Arrendador, por todas las obligaciones contraídas en presente
              Contrato y hasta la total liquidación de las mismas.
            </Text>
             <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
              <Text style={styles.bold}>DÉCIMO TERCERA. </Text>
              Confidencialidad. Las Partes reconocen y aceptan que con motivo de
              la celebración del presente Contrato, tendrán acceso a la
              información propiedad de las Partes que, salvo las excepciones que se mencionan expresamente en esta
              Cláusula, se considera de carácter confidencial.
            </Text>
          </View>
        </View>

        {/* Right Column: DÉCIMO TERCERA clause */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
           <Text style={[styles.text, { marginBottom: 5 }]}>
              En consecuencia,
              las Partes manejarán toda la información que le sea proporcionada o
              a la que llegaren a tener acceso con motivo del presente Contrato
              con carácter de confidencial.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Las Partes se obligan expresamente a que el manejo de la
              información confidencial se llevará a cabo bajo los siguientes
              criterios:
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              (i) Guardar absoluta reserva sobre la información, políticas,
              procedimientos y operaciones que sean intercambiadas entre las
              Partes.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              (ii) A no revelar información confidencial a ninguna persona, sin
              la previa autorización por escrito de la parte divulgadora, salvo
              en el caso que se trate de empleados, consultores, agentes,
              administradores, socios y/o subcontratistas de cualquiera de las
              Partes que por el ámbito de la materia de su trabajo se relacionen
              con el objeto del presente Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              (iii) Las Partes se obligan a que en ningún momento o lugar,
              presente o futuro, podrán divulgar por cualquier medio escrito,
              verbal, visual, electrónico, magnético, planos, dibujos, diagramas
              o de cualquier otra forma o medio, conocido o por conocerse, el
              contenido total o parcial de cualquier información y/o documento
              considerado como confidencial que le sea proporcionado por la otra
              parte o al que llegare a tener acceso con motivo del presente
              Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              (iv) Las Partes se obligan a tomar todas las medidas necesarias
              para que el personal a su cargo cumpla y observe lo aquí
              estipulado, debiendo abstenerse de divulgar o reproducir parcial o
              totalmente la información de la que pudiere llegar a tener
              conocimiento.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              (v) A, previa petición por escrito de cualquiera de las Partes,
              devolver toda la información confidencial, que le haya sido
              proporcionada o a la que haya tenido acceso cualquiera de las
              Partes, dentro de los 15 (quince) días naturales siguientes,
              contados a partir de la fecha de firma de recibido de dicha
              petición, eliminando, en la medida que sea permitido por la
              legislación aplicable, todo residuo de información confidencial, en
              cualquier medio electrónico o escrito, conocido o por conocer.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              (vi) Los acuerdos y compromisos contenidos aquí establecidos no se
              aplicarán a la siguiente información:
           {"\n"}
            </Text> 

            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              a)Toda información que cualquiera de las Partes obtenga, de forma
              legal, por parte de terceros o por mutuo propio en ningún momento y
              bajo ninguna circunstancia podrá ser considerada como confidencial.
            </Text>
            
           
          </View>
        </View>
      </View>

      {/* New Row for Page 11 Flow (DÉCIMO TERCERA continued) */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          fontSize: 10,
        }}
      >
        {/* Left Column: Empty for now */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
             <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              b) La información que sea de dominio público o que posteriormente se
              haga de dominio público por cualquier otro motivo que no sea el
              resultado de una revelación por parte cualquiera de las Partes, en
              incumplimiento de los términos y condiciones del Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              c) Que ya estuviera, de forma legal, en poder de cualquiera de las
              Partes antes de que le fuera suministrada, siempre que dicha
              información no fuera objeto de otro acuerdo de confidencialidad, o
              constituya otra obligación de confidencialidad.
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              d) Que la revelación de la misma fuera exigida por cualquier
              legislación vigente y aplicable o resolución de autoridad
              competente.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Las Partes acuerdan que, con el fin de proteger suficientemente la
              confidencialidad de cualquier información de la que tengan
              conocimiento con motivo de la celebración del Contrato, las
              obligaciones de confidencialidad establecidas en este instrumento
              surtirán efectos a partir de la fecha de firma del mismo y su
              vigencia concluirán hasta que transcurran 2 (dos) años, contados a
              partir de la fecha de terminación de la relación comercial
              establecida mediante el presente Contrato.
            </Text>

             
            <Text style={[styles.text, { marginBottom: 5 }]}>
               <Text style={styles.bold}>DÉCIMO CUARTA. </Text>
              Protección de Datos Personales. En el marco de la Ley Federal de Protección de Datos Personales en
              Posesión de Particulares ("LFPDPPP") y su respectivo reglamento, el
              Arrendador ha puesto, previo a la celebración del presente Contrato,
              a disposición del Arrendatario su aviso de privacidad (el "Aviso de
              Privacidad"), mismo que el Arrendatario declara conocer, además de
              haber leído y aceptado todos los términos expuestos en el mismo. En
              dicho Aviso de Privacidad se encuentran las finalidades y los
              términos que se sujetarán las transferencias de datos personales.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              En virtud de lo anterior y con motivo del presente Contrato, el
              Arrendador tendrá acceso y tratará datos personales del Arrendatario
              en su calidad de responsable, los cuales están sujetos a los
              términos y condiciones que se hacen constar en el Aviso de Privacidad
              expedido por el Arrendador, quien asumirá las obligaciones que les
              correspondan en su calidad de responsable, de acuerdo con lo
              establecido en la LFPDPPP, su reglamento y el propio Aviso de
              Privacidad del Arrendador.
            </Text>

             
            <Text style={[styles.text, { marginBottom: 5 }]}>
               <Text style={styles.bold}>DÉCIMO QUINTA. </Text>
              Responsabilidad Laboral. Las Partes reconocen y aceptan que el presente Contrato es
              estrictamente de arrendamiento sin que el mismo reúna alguna otra
              
            </Text>
          </View>
        </View>

        {/* Right Column: DÉCIMO QUINTA continued */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
              naturaleza jurídica, concretamente no existe prestación de trabajo
              personal subordinado mediante el pago de un salario, sino que
              implica un arrendamiento respecto del Bien Arrendado, siendo el
              Arrendador quien da en arrendamiento del Bien Arrendado al
              Arrendatario a cambio de la Contraprestación, por ende, las Partes
              reconocen y aceptan que las únicas relaciones jurídicas
              existentes entre ellas son las derivadas del presente Contrato,
              razón por la cual cada una de las Partes será la única responsable
              del personal que contrate y utilice en el desarrollo del mismo, el
              cual se entenderá bajo su inmediata dirección y dependencia, del
              pago de salarios ordinarios y extraordinarios, vacaciones,
              aguinaldos, primas de antigüedad, así como de cualquier otra
              prestación que por motivo de su trabajo pudiera corresponderle, por
              lo que ninguna de las Partes aceptará reclamación alguna por los
              conceptos antes citados, obligándose la parte que incumpla a sacar
              en paz y a salvo a la otra, así como a sus accionistas,
              funcionarios, representantes y asesores de cualquier reclamación que
              intente en su contra el personal y terceros relacionados con la
              parte que incumpla, además de reembolsarle a la vista a la parte
              afectada, sus accionistas, funcionarios, representantes y asesores
              cualquier cantidad que éstos eroguen por tal motivo tan pronto como
              fuera requerido para ello, contra entrega de los comprobantes
              respectivos.
            </Text>

             
            <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
               <Text style={styles.bold}>DÉCIMO SEXTA. </Text>
              Seguros
              Durante la vigencia del presente Contrato, y hasta en tanto se
              liquide cualquier saldo insoluto al amparo del mismo una vez, el
              Bien Arrendado deberá de estar en todo momento y sin periodos al
              descubierto, asegurado bajo las condiciones que se describen en este
              Contrato por lo que el Arrendatario se obliga a contratar una póliza
              de seguro de auto para el Bien Arrendado, por conducto del
              Arrendador, a más tardar a la fecha de firma del presente Contrato
              con una institución de seguros autorizada por la Comisión Nacional
              de Seguros y Fianzas.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              El Arrendador pondrá a disposición del Arrendatario una lista de
              aseguradoras para que éste elija aquella que le resulte más
              conveniente, con quien contratará el seguro por la vigencia del
              Contrato. Dicho seguro, en su caso, deberá renovarse automáticamente
              previo a su vencimiento con el fin de cumplir lo establecido en el
              párrafo anterior de la presente Cláusula. Asimismo, 
            </Text>
          </View>
        </View>
        
      </View>

      {/* New Row for DÉCIMO SEXTA continued */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          fontSize: 10,
        }}
      >
        {/* Left Column: DÉCIMO SEXTA continued */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              para la
              renovación del seguro, ya sea anual o multianual, el Arrendatario
              autoriza expresamente al Arrendador para que el importe de la prima
              y gasto de la póliza de seguro, sean pagadas por el Arrendador con
              cargo al saldo insoluto del Contrato de Arrendamiento, mismo que
              será pagadero por el Arrendatario.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              La póliza de seguro que en su caso se contrate deberá de incluir una
              disposición que establezca que el Arrendador o quien decida el
              Arrendador, será designado como el único beneficiario preferente de
              las mismas y que las pólizas de seguros únicamente serán modificadas
              o canceladas con la previa aprobación por escrito del Arrendador.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              En caso de que al término del presente Contrato, el Arrendatario
              tuviere algún saldo insoluto con respecto del Bien Arrendado, el
              Arrendatario se obliga a pagar, por medio del Arrendador, y mantener
              en vigor, una póliza de seguro en tanto dicho saldo no hubiere sido
              liquidado.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              En caso de incumplimiento por parte del Arrendatario a la obligación
              descrita en los párrafos anteriores de esta Cláusula, la
              contratación, así como el pago de las renovaciones de las pólizas de
              seguro podrán hacerse a través del Arrendador. En virtud de lo
              anterior, el Arrendatario se obliga a reembolsar al Arrendador los
              pagos que este hubiere realizado a efectos de contratar dichas
              pólizas. Para dichos efectos, el Arrendatario deberá realizar el
              reembolso del pago de la póliza respectiva así como el pago de la
              cuota por reembolso que se describe en la Carátula del presente
              Contrato, en una sola exhibición, a más tardar dentro de los 30
              (treinta) días naturales siguientes a la celebración del presente
              Contrato, o en parcialidades con cargo al monto de la
              Contraprestación mensual, por el número de meses del que se componga
              la vigencia del Contrato, en el entendido de que el Arrendatario
              responderá ante el Arrendador en caso de que por cualquier causa la
              compañía aseguradora se abstenga de hacer frente a sus obligaciones
              derivadas de la o las pólizas correspondientes.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Las Partes convienen que transcurrido un año posterior a la firma
              del presente Contrato, el Arrendador se reserva el derecho con
              respecto del Bien Arrendado, de requerir al Arrendatario el
              incremento en el monto de las coberturas señaladas anteriormente, a
              fin de actualizar las condiciones que prevalezcan en ese momento.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Cualquier gasto del Arrendador realizado con el fin de ajustar o
              cobrar los seguros será cubierto por el Arrendatario, sin que el
              Arrendatario pueda realizar ajustes o cobrar cualesquiera
              
            </Text>
           
          </View>
        </View>

        {/* Right Column: Empty for now */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
          <Text style={[styles.text, { marginBottom: 5 }]}>
              
              indemnizaciones por seguros directamente de las compañías
              aseguradoras salvo que cuente con el consentimiento previo y por
              escrito del Arrendador.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              El Arrendatario conviene y se obliga en notificar de manera
              inmediata, colaborar con el Arrendador o incluso en realizar
              cualesquiera acciones, dar cualquier aviso y llevar a cabo
              cualesquiera otros actos o formalidades requeridas por la compañía
              de seguros u otras personas o autoridades, para que, en caso de
              pérdida, robo, destrucción o cualquier daño sufrido por el Bien
              Arrendado, obtenga el pago inmediato de los daños, gastos y
              pérdidas, en términos de lo dispuesto en la Cláusula Séptima del
              presente Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              El pago del deducible correspondiente lo hará el Arrendatario en
              todos los casos, en el supuesto que el Arrendatario incumpliera con
              dicha obligación de pago ante la aseguradora, el Arrendador podrá
              optar en utilizar el depósito en garantía para cubrir dicho pago. En
              caso de que el Bien Arrendado se utilice ocasionalmente en los
              Estados Unidos de América o Canadá, el Arrendatario deberá contratar
              seguros adicionales requeridos por la legislación aplicable,
              asimismo, siendo cualquier responsabilidad derivada del uso del Bien
              Arrendado fuera de los Estados Unidos Mexicano responsabilidad
              exclusiva del Arrendatario.
            </Text>

             
            <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
               <Text style={styles.bold}>DÉCIMO SÉPTIMA. </Text>
              Pagaré
              Para garantizar el pago de la totalidad de las Contraprestaciones
              estipuladas en el presente Contrato y sus Anexos, el Arrendatario
              y/o el Obligado Solidario se obligan a suscribir en la fecha de
              suscripción, renovación y/o prórroga, un pagaré a favor del
              Arrendador, en términos similares al formato que de dicho documento
              se adjunta al presente como Anexo 3, pagadero en el número de
              amortizaciones vencidas, consecutivas y con vencimientos sucesivos
              de conformidad con la vigencia del presente Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Asimismo, con el fin de garantizar el cumplimiento de las
              obligaciones del Arrendatario en términos de lo dispuesto en las
              Cláusulas Séptima, Vigésima y demás relativas, éste se obliga a
              suscribir un pagaré a favor del Arrendador, en términos similares al
              formato que de dicho documento se adjunta al presente como Anexo 4,
              por la cantidad del valor residual del Bien Arrendado.
            </Text>

            <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
              <Text style={styles.bold}>DÉCIMO OCTAVA. </Text>
              Terminación Anticipada, Rescisión y Recuperación del vehículo
            </Text>
            
          </View>
        </View>
        
      </View>

      {/* New Row for DÉCIMO OCTAVA continued */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          fontSize: 10,
        }}
      >
        {/* Left Column: DÉCIMO OCTAVA continued */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              (1) Las Partes convienen que, si el Arrendatario decidiera dar por
              terminado de forma anticipada el presente Contrato, deberá dar aviso
              por escrito al Arrendador con por lo menos 30 (treinta) días
              naturales de anticipación a la fecha en que deba surtir efectos la
              terminación anticipada, en el entendido que, en tal caso el
              Arrendatario se obliga a pagar al Arrendador la totalidad de las
              Contraprestaciones y Cuotas de Administración por devengar, debiendo
              devolver el Arrendatario al Arrendador, a más tardar en la fecha de
              terminación, el Bien Arrendado.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              (2) No obstante lo anterior, las Partes convienen que serán causas
              de rescisión del presente Contrato imputables al Arrendatario las
              siguientes:
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              1. Por la falta de pago oportuno y total a su vencimiento por parte
              del Arrendatario de una o más Contraprestaciones, Cuotas de
              Administración y demás conceptos establecidos en el presente Contrato
              y en los Anexos de este.
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              2. Por el incumplimiento por parte del Arrendatario a cualquiera de
              sus obligaciones contenidas en este Contrato distintas a las
              obligaciones de pago; incluyendo las obligaciones establecidas en la
              Cláusula Décimo Primera o aquellas relacionadas con las pólizas de
              seguros a que hace referencia la Cláusula Décimo Sexta anterior.
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              3. El subarrendamiento del Bien Arrendado sin previa autorización
              por escrito por parte del Arrendador.
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              4. Si cualquier declaración efectuada o documento entregado por el
              Arrendatario y/o el Obligado Solidario en el presente Contrato
              resultare falsa.
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              5. Si cualquier certificación, reporte, póliza o documento entregado
              por el Arrendatario al Arrendador en relación con el presente
              Contrato contenga información falsa.
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              6. Que no realice las acciones legales correspondientes para la
              recuperación integral del Bien Arrendado en caso de que éstos fueren
              embargados por causa de un adeudo vencido del Arrendatario con un
              tercero.
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              7. Que el Arrendatario se encuentre en suspensión de pagos o quiebra
              declarada judicialmente.
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              8. La muerte del Arrendatario.
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              9. Por no acudir a las citas de revisión y/o reparación, limite la
              asistencia de técnicos a su domicilio para realizar el diagnóstico
              y/o reparación, no procure el correcto funcionamiento del Bien
              Arrendado, manipule o extraiga el Dispositivo de Geolocalización, 
            </Text>
          </View>
        </View>

        {/* Right Column: Empty for now */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
               sin
              previo consentimiento por escrito del Arrendador o bien se haya
              efectuado reparaciones o modificaciones por un tercero en
              contravención a lo establecido en el presente Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              En caso de que el Arrendatario incurra en alguna de las causas de
              rescisión mencionadas en el inciso (2) esta Cláusula y en
              consecuencia el Arrendador rescinda el presente Contrato, sin
              necesidad de declaración judicial alguna, el Arrendatario se obliga a
              pagar al Arrendador como pena convencional la cantidad que resulte
              mayor entre el total de las Contraprestaciones y Cuotas de
              Administración por devengar a que tiene derecho el Arrendador en
              términos del presente Contrato y la cantidad que se establece en la
              Carátula del presente Contrato por dicho concepto, en el entendido
              que el Arrendatario, mientras no entregue al Arrendador la posesión
              del Bien Arrendado, en términos satisfactorios para el Arrendador, el
              Arrendatario continuará obligado a pagar la Contraprestación y la
              Cuota de Administración en términos de lo establecido en la Cláusula
              Segunda anterior.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              (3) No obstante lo anterior, el Arrendatario conviene, acepta y
              reconoce que en los casos de vencimiento anticipado y/o rescisión del
              Contrato, el incumplimiento del Arrendatario faculta al Arrendador
              para inmovilizar y recuperar la posesión del Bien Arrendado donde
              quiera que éste se encuentre, sin necesidad de resolución judicial y
              sin perjuicio de aquellas acciones judiciales de naturaleza penal,
              civil o mercantil que resulten aplicables en favor del Arrendador y
              que este pudiera ejercer en contra del Arrendatario.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              El Arrendatario expresamente acepta que, una vez inmovilizado el Bien
              Arrendado, cualquier intento de su parte por moverlo o utilizarlo por
              el medio que fuese, así como cualquier intento o acción tendiente a
              inutilizar, modificar o de cualquier manera alterar el dispositivo
              inmovilizador constituirá un apoderamiento con ánimo de dominio sin
              consentimiento del Arrendador.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              En adición a lo anterior, el Arrendatario se obliga a pagar al
              Arrendador el costo por recuperación y traslado del Bien Arrendado
              (los "Gastos de Recuperación").
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              (4) La falta de pago de la Contraprestación y Cuota de Administración
              por 30 (treinta) días naturales o más, adicional al cobro de los
              intereses moratorios y al cobro de la comisión por Gastos de Cobranza
              facultarán al arrendador a cobrar los Gastos de Recuperación.
            </Text>
            
            
          </View>
        </View>
        
      </View>

       <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          fontSize: 10,
        }}
      >
        {/* Left Column: DÉCIMO OCTAVA continued */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
          <Text style={[styles.text, { marginBottom: 5 }]}>
              Una vez recuperado el Bien Arrendado por el Arrendador, y en caso de
              que el Arrendatario solicite que se le sea devuelto el mismo, este
              deberá de:
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              1. Realizar el pago de los Gastos de Recuperación;
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              2. Realizar el pago de los Gastos de Cobranza y los intereses
              moratorios que se hubieren generado previo a la solicitud de
              devolución; y
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              3. Liquidar la totalidad de las Contraprestaciones y Cuotas de
              Administración pendientes de pago, así como aquellas pendientes de
              devengar más el valor residual a la fecha de la solicitud.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              No obstante, lo anterior, en caso de que el Arrendatario pague los
              saldos insolutos o acuerde con el Arrendador la terminación
              anticipada del presente Contrato previo a la inmovilización del Bien
              Arrendado, el Arrendatario no estará obligado a pagar los Gastos de
              Recuperación.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              (5) No obstante lo anterior, las Partes convienen que serán causas de
              rescisión del presente Contrato, aquellas imputables al Arrendador
              por el incumplimiento de sus obligaciones al amparo del presente
              Contrato.
            </Text>

              
            <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
              <Text style={styles.bold}>DÉCIMO NOVENA. </Text>
              Compra del Bien Arrendado.
              De forma previa la terminación del presente Contrato, y siempre y
              cuando el Arrendatario se encuentre al corriente en el cumplimiento
              de todas y cada una de las obligaciones a su cargo vigentes al amparo
              de este en la fecha respectiva, el Arrendatario tendrá derecho
              preferente para adquirir el Bien Arrendado, de conformidad con las
              siguientes reglas:
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              a) El Arrendatario deberá notificar por escrito al Arrendador, con
              cuando menos 60 (sesenta) días naturales de anticipación a la fecha
              de terminación del presente Contrato o cualquier extensión del mismo,
              su deseo de adquirir el Bien Arrendado, indicando en dicha
              notificación, además, si la compra del Bien Arrendado se efectuará
              directamente por parte del Arrendatario o por algún tercero ("Tercero
              Autorizado") propuesto por el Arrendatario, cuya información y la
              relación que tiene dicho tercero con el Arrendatario deberá indicarse
              en la comunicación antes mencionada, en el entendido que el
              Arrendador se reserva el derecho de autorizar la venta de Bien
              Arrendado al Tercero Autorizado.
            </Text>
             <Text style={[styles.text, { marginBottom: 5, marginLeft: 10, marginTop: 5 }]}>
              b) Dentro de los 30 (treinta) días naturales siguientes a la fecha
              de recepción de la notificación mencionada en el párrafo anterior, 
            </Text>
          </View>
        </View>

        {/* Right Column: DÉCIMO NOVENA continued */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              el
              Arrendador confirmará al Arrendatario por escrito, el precio del
              vehículo del Bien Arrendado el cual no podrá ser mayor a la cantidad
              que se señala en la Carátula (en adelante, el "Precio del Vehículo").
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              c) En caso de que el Arrendatario notifique al Arrendador su deseo de
              adquirir el Bien Arrendado al Precio del Vehículo respectivo de
              conformidad con lo previsto en la presente Cláusula, el Arrendador
              celebrará con el Arrendatario o el Tercero Autorizado, según
              corresponda, un contrato de compraventa respecto del Bien Arrendado,
              a más tardar en la fecha de terminación del presente Contrato,
              estando obligado el Arrendatario o el Tercero Autorizado, a pagar al
              Arrendador, en la fecha de terminación del Contrato el Precio del
              Vehículo respectivo, así como el importe de todos los impuestos que
              fueren aplicables a dicha compraventa (con excepción de aquellos
              impuestos que gravan los ingresos del Arrendador) y cualesquiera
              otras cantidades que se encuentren pendientes de pago; el Arrendador
              transmitirá al Arrendatario, libre de gravámenes, la propiedad del
              Bien Arrendado en el estado en que se encuentra, en el lugar donde
              señale el Arrendador y con todos sus defectos, sin responsabilidad o
              garantía alguna y mediante la entrega de la factura y demás
              documentación aplicable, por lo que el Arrendatario o el Tercero
              Autorizado será el único responsable de, y en este acto se obliga
              expresamente a pagar y reembolsar al Arrendador respecto de todos los
              costos, actos y registros, que deban iniciarse, así como todos y cada
              uno de los procedimientos o trámites o firmar y entregar cualesquier
              documentos ante cualquier autoridad gubernamental que resulten
              necesarios o convenientes.
            </Text>
            <Text style={[styles.text, { marginBottom: 5, marginLeft: 10 }]}>
              d) Asimismo, las Partes convienen que, si el Arrendador no autoriza
              la venta del Bien Arrendado al Tercero Autorizado por el
              Arrendatario, la venta del referido Bien Arrendado únicamente podrá
              llevarse a cabo en favor del Arrendatario, sin que lo anterior se
              considere como algún tipo de incumplimiento del Arrendador a sus
              obligaciones al amparo del presente Contrato.
            </Text>

            
            <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
                <Text style={styles.bold}>VIGÉSIMA. </Text>
              Devolución del Bien Arrendado
              En caso de terminación del presente Contrato por cualquier causa, el
              Arrendatario se obliga devolver el Bien Arrendado al Arrendador, en
              el domicilio de este último, el día en que surta efectos la
              terminación o recisión del presente Contrato, sin perjuicio de las
            </Text>
           
          </View>
        </View>
        
      </View>

      {/* New Row for VIGÉSIMA continued */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          fontSize: 10,
        }}
      >
        {/* Left Column: VIGÉSIMA continued */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              demás obligaciones que deberá de cumplir el Arrendatario en términos
              de lo establecido en el presente Contrato.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              En el supuesto que el Arrendatario continúe en posesión del Bien
              Arrendado en dicha fecha, se estará a lo dispuesto en el presente
              Contrato respecto a las prórrogas y a las penas convencionales en
              términos de las Cláusulas Segunda y Décimo Octava.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Asimismo, en caso de que al momento de la devolución del Bien
              Arrendado éste se encuentre en malas condiciones, lo cual incluye sin
              limitar que se encuentre con golpes, abolladuras, autopartes
              faltantes y demás aplicables, el Arrendatario se obliga a pagar lo
              que resulte mayor entre la pena convencional que se describe en la
              carátula del presente Contrato o el costo de las reparaciones del
              Bien Arrendado.
            </Text>

             
            <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
               <Text style={styles.bold}>VIGÉSIMO PRIMERA. </Text>
              Subarrendamiento
              Queda totalmente prohibido al Arrendatario subarrendar el Bien
              Arrendado, así como cualquier accesorio de este, y será causal de
              rescisión en términos de lo establecido en el presente Contrato.
            </Text>

            
            <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
              <Text style={styles.bold}>VIGÉSIMO SEGUNDA. </Text>
              Impuestos
              Con excepción del Impuesto Sobre la Renta que corresponde al
              Arrendador, el IVA y cualquier otra forma de contribución fiscal que
              llegue a causarse con motivo de la celebración y operación del
              presente Contrato estará a cargo del Arrendatario y el Arrendador lo
              trasladará expresamente en las facturas correspondientes, cuando así
              proceda.
            </Text>

            
            <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
              <Text style={styles.bold}>VIGÉSIMO TERCERA. </Text>
              Cesión
              El Arrendador podrá ceder, gravar o traspasar en todo o en parte los
              derechos y las obligaciones a su cargo consignadas en este Contrato,
              previa notificación por escrito a la otra parte.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              El Arrendatario no podrá ceder, gravar o traspasar en todo o en parte
              los derechos y las obligaciones a su cargo consignadas en este
              Contrato, sin previa autorización por escrito por parte del
              Arrendador.
            </Text>

            
            <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
              <Text style={styles.bold}>VIGÉSIMO CUARTA. </Text>
              Modificaciones
              Todas las modificaciones al presente Contrato deberán constar por
              escrito y ser firmadas por ambas Partes.
            </Text>

            
              <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
              <Text style={styles.bold}>VIGÉSIMO QUINTA. </Text>
              Integridad del Contrato
              El presente Contrato constituye el único y total acuerdo entre las
              Partes con relación al objeto de este, por lo que ambas partes
              acuerdan
            </Text>
          </View>
        </View>

        {/* Right Column: Empty for now */}
        <View style={{ width: "48%" }}>
          <View style={{ marginLeft: 0 }}>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              dejar sin efectos legales cualquier otro acuerdo verbal o
              escrito que hayan celebrado con anterioridad.
            </Text>

        
            <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
                    <Text style={styles.bold}>VIGÉSIMO SEXTA. </Text>
              Notificaciones y Domicilios
              Todos los avisos y demás comunicaciones, en relación con el presente
              Contrato deberán constar por escrito, y serán entregadas o enviadas
              (i) personalmente a los domicilios que cada parte señala en el
              apartado de declaraciones del presente Contrato, según corresponda,
              (ii) por servicio de mensajería especializado, (iii) por correo
              certificado con acuse de recibo, (iv) por correo electrónico o (v)
              por facsímile, y serán efectivas cuando éstas sean recibidas en
              términos de lo anterior.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Cada una de las Partes está facultada, en cualquier momento, para
              cambiar su domicilio por medio de un aviso por escrito dirigido a la
              otra parte con por lo menos 30 (treinta) días naturales de
              anticipación, de conformidad con lo dispuesto en la presente
              Cláusula.
            </Text>
            <Text style={[styles.text, { marginBottom: 5 }]}>
              Mientras las Partes no notifiquen por escrito el cambio de los
              domicilios anteriormente señalados, todas las notificaciones que en
              éstos se hagan se tendrán como legal y válidamente realizadas, por lo
              que surtirán plenos efectos legales.
            </Text>

           
            <Text style={[styles.text, { marginBottom: 5, marginTop: 10 }]}>
              <Text style={styles.bold}>VIGÉSIMO SÉPTIMA. </Text>
              Jurisdicción
              El presente Contrato y los demás documentos que deban ser celebrados
              conforme al mismo, se regirán conforme a las leyes aplicables en los
              Estados Unidos Mexicanos. Para todo lo relativo a la interpretación y
              cumplimiento del presente Contrato las Partes se someten en forma
              expresa e irrevocable a las leyes y tribunales competentes de la
              Ciudad de México renunciando las Partes expresa e irrevocablemente a
              cualquier otra jurisdicción que pudiera corresponderles por razón de
              sus domicilios presentes o futuros o por cualquier otra causa.
            </Text>
          </View>
        </View>
        
      </View>

      <SignatureSection data={data} type={type} isFinalSignature={true} />
    </View>
  );
};
